var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isAma
    ? _c("div", { class: [_vm.theme === 1 ? "" : "theme-2"] }, [
        _c("div", { staticClass: "row" }, [
          _vm.isGioielleriaItalianaB2B && _vm.fastDeliveryItems.length > 0
            ? _c("div", { staticClass: "col-12 mb-3" }, [
                _c(
                  "div",
                  {
                    staticClass: "option-label row",
                    staticStyle: { "border-left": "none !important" }
                  },
                  [
                    _c("div", { staticClass: "col-10 pl-0" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("fastDelivery")) + " "),
                          _c("img", {
                            staticClass: "d-inline-block fast-delivery-img",
                            attrs: {
                              src:
                                "https://content-test.gioielleriaitaliana.com/cr/configuratore/icons/fast_delivery.png"
                            }
                          })
                        ]
                      )
                    ]),
                    _c("div", { staticClass: "col-2 text-right" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fastDelivery,
                            expression: "fastDelivery"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.fastDelivery)
                            ? _vm._i(_vm.fastDelivery, null) > -1
                            : _vm.fastDelivery
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = _vm.fastDelivery,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.fastDelivery = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.fastDelivery = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.fastDelivery = $$c
                              }
                            },
                            function($event) {
                              return _vm.fastDeliverySelection()
                            }
                          ]
                        }
                      })
                    ])
                  ]
                ),
                _vm.fastDelivery
                  ? _c(
                      "div",
                      { staticClass: "w-100 pt-2 pl-3 fast-delivery-div" },
                      _vm._l(_vm.fastDeliveryItems, function(option) {
                        return _c(
                          "div",
                          {
                            staticClass: "row fast-delivery-option",
                            class: {
                              selected: _vm.selectedFastDeliveryItem == option
                            }
                          },
                          [
                            _c("div", { staticClass: "col-xl-5 col-12" }, [
                              _c("img", {
                                attrs: {
                                  height: "100",
                                  src: _vm.baseImageUrl + option.images[0]
                                }
                              })
                            ]),
                            _c(
                              "div",
                              { staticClass: "col-xl-7 col-12" },
                              [
                                _vm._l(option.k, function(opt, index) {
                                  return _c("div", { key: opt }, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "option_" +
                                              _vm.currentJewelSelection.options[
                                                index
                                              ].type
                                          )
                                        ) + ":"
                                      )
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getOptionValueLabel(
                                            _vm.currentJewelSelection.options[
                                              index
                                            ].values,
                                            opt,
                                            option.k[
                                              _vm.currentJewelSelection.options.findIndex(
                                                function(o) {
                                                  return o.type == "gold"
                                                }
                                              )
                                            ]
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                }),
                                _c("div", { staticClass: "mt-2 red" }, [
                                  option.availability == 1
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(option.availability) +
                                            " " +
                                            _vm._s(_vm.$t("pieceAvailable"))
                                        )
                                      ])
                                    : _vm._e(),
                                  option.availability > 1
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(option.availability) +
                                            " " +
                                            _vm._s(_vm.$t("piecesAvailable"))
                                        )
                                      ])
                                    : _vm._e()
                                ])
                              ],
                              2
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xl-12 col-12 fast-delivery-selection-btn"
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn w-100",
                                    on: {
                                      click: function($event) {
                                        _vm.selectedFastDeliveryItem = option
                                        _vm.fastDeliverySelectionItem(
                                          _vm.selectedFastDeliveryItem
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm.selectedFastDeliveryItem == option
                                      ? _c("span", [
                                          _vm._v(_vm._s(_vm.$t("selected")))
                                        ])
                                      : _c("span", [
                                          _vm._v(_vm._s(_vm.$t("select")))
                                        ])
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          !_vm.fastDelivery
            ? _c(
                "div",
                { staticClass: "w-100" },
                [
                  _vm._l(_vm.stoneColorObj, function(valueObj) {
                    return valueObj.values.length > 1
                      ? _c(
                          "div",
                          { key: valueObj.id, staticClass: "col-12 mb-3" },
                          [
                            _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass: "option-label row",
                                  staticStyle: {
                                    "border-left": "none !important"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "option-label-title" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-left mb-0 pl-5 text-uppercase label-menu"
                                        },
                                        [_vm._v(_vm._s(_vm.$t("stoneColor")))]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "option-label-info" },
                                    [
                                      _c(
                                        "v-popover",
                                        {
                                          attrs: {
                                            popoverClass: "tooltip-custom",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass:
                                              "info-button cursor-pointer",
                                            attrs: {
                                              icon: ["fas", "info-circle"]
                                            }
                                          }),
                                          _c(
                                            "template",
                                            { slot: "popover" },
                                            [
                                              _c("JewelDescriptionTooltip", {
                                                attrs: {
                                                  data: valueObj.values,
                                                  type: "stone"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "w-100 row pt-2 pl-5" },
                                _vm._l(valueObj.values, function(stone) {
                                  return _c("div", { key: stone.id }, [
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.top",
                                          value: {
                                            content: stone.label,
                                            trigger: "hover click focus",
                                            delay: { show: "200", hide: "500" }
                                          },
                                          expression:
                                            "{\n                  content: stone.label,\n                  trigger: 'hover click focus',\n                  delay: { show: '200', hide: '500' },\n                }",
                                          modifiers: { top: true }
                                        }
                                      ],
                                      staticClass:
                                        "rounded-circle cursor-pointer",
                                      class: { disableImg: stone.disabled },
                                      style: {
                                        border:
                                          _vm.selectedStoneObj[valueObj.type] ==
                                          stone.id
                                            ? "1px solid"
                                            : "",
                                        opacity: stone.disabled ? "0.2" : "1"
                                      },
                                      attrs: {
                                        src: _vm.baseImageUrl + stone.image,
                                        height: "40",
                                        width: "40"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.triggerToChange(
                                            stone.id,
                                            "stone",
                                            valueObj.type
                                          )
                                        }
                                      }
                                    })
                                  ])
                                }),
                                0
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._l(_vm.stoneSizeObj, function(objSize, key) {
                    return objSize.values.length > 1
                      ? _c(
                          "div",
                          { key: objSize.id, staticClass: "col-12 mb-3" },
                          [
                            _c(
                              "div",
                              { staticClass: "option-label row border-left-0" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "option-label-title" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-left mb-0 pl-5 text-uppercase label-menu"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("measureChoice")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "option-label-info",
                                    staticStyle: { "z-index": "999" }
                                  },
                                  [
                                    _c(
                                      "v-popover",
                                      {
                                        staticClass: "d-inline-block",
                                        attrs: {
                                          popoverClass:
                                            "tooltip-custom d-inline-block",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass:
                                            "info-button cursor-pointer",
                                          attrs: {
                                            icon: ["fas", "info-circle"]
                                          }
                                        }),
                                        _c(
                                          "template",
                                          { slot: "popover" },
                                          [
                                            _c("JewelDescriptionTooltip", {
                                              attrs: {
                                                description: _vm.$t(
                                                  "tooltipMeasureChoice"
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "row pt-3 pl-5" },
                              [
                                _c(
                                  "select",
                                  {
                                    staticClass: "w-100 select-setting",
                                    domProps: {
                                      value:
                                        _vm.selectedStoneSizeObj[objSize.type]
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.triggerToChange(
                                          $event.target.value,
                                          "size",
                                          objSize.type
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: null } }),
                                    _vm._l(objSize.values, function(size) {
                                      return _c(
                                        "option",
                                        {
                                          key: size.id,
                                          attrs: { disabled: size.disabled },
                                          domProps: { value: size.id }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(size.label) +
                                              " " +
                                              _vm._s(
                                                objSize.sizeUnit === "MM"
                                                  ? "mm"
                                                  : "ct"
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    })
                                  ],
                                  2
                                ),
                                objSize.type == 0 && _vm.credential.isBO
                                  ? _c("CaratsTable", {
                                      attrs: { selectObj: _vm.selectObj }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm.golds && _vm.golds.length > 0
                    ? _c("div", { staticClass: "col-12 mb-3" }, [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "option-label row",
                              staticStyle: { "border-left": "none !important" }
                            },
                            [
                              _c("div", [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-left pl-5 text-uppercase label-menu"
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("goldColor")) + " "
                                    )
                                  ]
                                )
                              ])
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "w-100 row pt-2 pl-5" },
                            _vm._l(_vm.golds, function(gold) {
                              return _c("div", { key: gold.id }, [
                                _c("img", {
                                  staticClass:
                                    "rounded-circle mr-2 cursor-pointer",
                                  class: { disableImg: gold.disabled },
                                  style: {
                                    border:
                                      _vm.selectedGold == gold.id
                                        ? "2px solid"
                                        : "",
                                    opacity: gold.disabled ? "0.2" : "1"
                                  },
                                  attrs: {
                                    src: _vm.baseImageUrl + gold.image,
                                    alt: "",
                                    height: "35",
                                    width: "35"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.triggerToChange(gold.id, "0")
                                    }
                                  }
                                })
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm.goldKarats && _vm.goldKarats.length > 0
                    ? _c("div", { staticClass: "col-12 mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "option-label row border-left-0" },
                          [
                            _c("div", { staticClass: "col-8 pl-0" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-left pl-5 text-uppercase label-menu"
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("goldKarat")) + " "
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "col-4 pl-0" }, [
                              _c(
                                "select",
                                {
                                  staticClass: "w-100 select-setting",
                                  domProps: { value: _vm.selectedGoldKarat },
                                  on: {
                                    change: function($event) {
                                      return _vm.triggerToChange(
                                        $event.target.value,
                                        "goldKarat"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: null } }),
                                  _vm._l(_vm.goldKarats, function(karat) {
                                    return _c(
                                      "option",
                                      {
                                        key: karat.id,
                                        attrs: { disabled: karat.disabled },
                                        domProps: { value: karat.id }
                                      },
                                      [_vm._v(" " + _vm._s(karat.label) + " ")]
                                    )
                                  })
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.sizes && _vm.sizes.length > 0
                    ? _c("div", { staticClass: "col-12 mb-3" }, [
                        _c(
                          "div",
                          { staticClass: "option-label row border-left-0" },
                          [
                            _c("div", { staticClass: "col-8 pl-0" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-left pl-5 text-uppercase label-menu"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "measure" +
                                            this.currentJewelSelection
                                              .categoryId
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "col-4 pl-0" }, [
                              _c(
                                "select",
                                {
                                  staticClass: "w-100 select-setting",
                                  domProps: { value: _vm.selectedSize },
                                  on: {
                                    change: function($event) {
                                      return _vm.triggerToChange(
                                        $event.target.value,
                                        "1"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("option", { domProps: { value: null } }),
                                  _vm._l(_vm.sizes, function(size) {
                                    return _c(
                                      "option",
                                      {
                                        key: size.id,
                                        attrs: { disabled: size.disabled },
                                        domProps: { value: size.id }
                                      },
                                      [_vm._v(" " + _vm._s(size.label) + " ")]
                                    )
                                  })
                                ],
                                2
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm.backings && _vm.backings.length > 0
                    ? _c("div", { staticClass: "col-12 mb-3" }, [
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "option-label row border-left-0" },
                            [
                              _c("div", { staticClass: "option-label-title" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-left pl-5 text-uppercase label-menu"
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("backing")) + " "
                                    )
                                  ]
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "option-label-info" },
                                [
                                  _c(
                                    "v-popover",
                                    {
                                      staticClass: "d-inline-block",
                                      attrs: {
                                        popoverClass:
                                          "tooltip-custom d-inline-block",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass:
                                          "info-button cursor-pointer",
                                        attrs: { icon: ["fas", "info-circle"] }
                                      }),
                                      _c(
                                        "template",
                                        { slot: "popover" },
                                        [
                                          _c("JewelDescriptionTooltip", {
                                            attrs: {
                                              data: _vm.backings,
                                              type: "backing"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "w-100" },
                            _vm._l(_vm.backings, function(backing) {
                              return _c("div", { key: backing.id }, [
                                _c("div", { staticClass: "row pt-2 pl-5" }, [
                                  _c("img", {
                                    staticClass:
                                      "rounded-circle mr-2 backing-img",
                                    class: { disableImg: backing.disabled },
                                    attrs: {
                                      src: _vm.baseImageUrl + backing.image,
                                      alt: "",
                                      height: "50",
                                      width: "50"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.triggerToChange(
                                          backing.id,
                                          "2"
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "backing-label pl-2 cursor-pointer mt-2",
                                      class: {
                                        "backing-label-selected": _vm.checkSelectionOption(
                                          backing.id,
                                          "backing"
                                        ),
                                        disableImg: backing.disabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.triggerToChange(
                                            backing.id,
                                            "2"
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(backing.label) + " ")]
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm.chains && _vm.chains.length > 0
                    ? _c("div", { staticClass: "col-12 mb-3" }, [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "option-label row",
                              staticStyle: { "border-left": "none !important" }
                            },
                            [
                              _c("div", { staticClass: "option-label-title" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "text-left pl-5 text-uppercase label-menu"
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("chain")) + " ")]
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "option-label-info" },
                                [
                                  _c(
                                    "v-popover",
                                    {
                                      staticClass: "d-inline-block",
                                      attrs: {
                                        popoverClass:
                                          "tooltip-custom d-inline-block",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass:
                                          "info-button cursor-pointer",
                                        attrs: { icon: ["fas", "info-circle"] }
                                      }),
                                      _c(
                                        "template",
                                        { slot: "popover" },
                                        [
                                          _c("JewelDescriptionTooltip", {
                                            attrs: {
                                              data: _vm.chains,
                                              type: "chain"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "w-100 pl-5" },
                            _vm._l(_vm.chains, function(chain) {
                              return _c("div", { key: chain.id }, [
                                _c("div", { staticClass: "row pt-2" }, [
                                  _c("img", {
                                    staticClass:
                                      "rounded-circle mr-2 backing-img",
                                    class: { disableImg: chain.disabled },
                                    attrs: {
                                      src: _vm.baseImageUrl + chain.image,
                                      alt: "",
                                      height: "50",
                                      width: "50"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.triggerToChange(
                                          chain.id,
                                          "4"
                                        )
                                      }
                                    }
                                  }),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "backing-label cursor-pointer mt-2",
                                      class: {
                                        "backing-label-selected": _vm.checkSelectionOption(
                                          chain.id,
                                          "chain"
                                        ),
                                        disableImg: chain.disabled
                                      },
                                      on: {
                                        click: function($event) {
                                          !chain.disabled
                                            ? _vm.triggerToChange(chain.id, "4")
                                            : null
                                        }
                                      }
                                    },
                                    [_vm._v(" " + _vm._s(chain.label) + " ")]
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm.letters && _vm.letters.length > 0
                    ? _c("div", { staticClass: "col-12 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "option-label row",
                            staticStyle: { "border-left": "none !important" }
                          },
                          [
                            _c("div", { staticClass: "col-9 pl-0" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-left mb-0 pl-5 text-uppercase label-menu"
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("letters")) + " ")]
                              )
                            ]),
                            _c("div", { staticClass: "col-3 pl-0" }, [
                              _c(
                                "select",
                                {
                                  staticClass: "row w-100 select-setting",
                                  domProps: { value: _vm.selectedLetter },
                                  on: {
                                    change: function($event) {
                                      return _vm.triggerToChange(
                                        $event.target.value,
                                        "13"
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.letters, function(letter) {
                                  return _c(
                                    "option",
                                    {
                                      key: letter.id,
                                      attrs: { disabled: letter.disabled },
                                      domProps: { value: letter.id }
                                    },
                                    [_vm._v(" " + _vm._s(letter.label) + " ")]
                                  )
                                }),
                                0
                              )
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "w-100" }, [
                    _vm.isLogoVisible
                      ? _c("div", { staticClass: "col-12 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticStyle: { "border-left": "none !important" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "option-label row pl-0 position-relative"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "option-label-title" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("engraveYourLogo")
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "option-label-info" },
                                    [
                                      _c(
                                        "v-popover",
                                        {
                                          staticClass: "d-inline-block",
                                          attrs: {
                                            popoverClass:
                                              "tooltip-custom d-inline-block",
                                            placement: "top"
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass:
                                              "info-button cursor-pointer",
                                            attrs: {
                                              icon: ["fas", "info-circle"]
                                            }
                                          }),
                                          _c(
                                            "template",
                                            { slot: "popover" },
                                            [
                                              _c("JewelDescriptionTooltip", {
                                                attrs: {
                                                  description: _vm.$t(
                                                    "tooltipEngraveYourLogo"
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-10 pl-0" }, [
                                  _vm.currentJewelSelection &&
                                  _vm.currentJewelSelection.logoPrice &&
                                  _vm.retailPerc === 1
                                    ? _c(
                                        "label",
                                        {
                                          staticClass:
                                            "text-left pl-5 incisione-label"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("addLogo")) +
                                              " + " +
                                              _vm._s(
                                                _vm.currentJewelSelection.logoPrice
                                                  .toFixed(2)
                                                  .replace(".", ",")
                                              ) +
                                              "€ "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _c("div", { staticClass: "col-2 text-right" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.logo,
                                        expression: "logo"
                                      }
                                    ],
                                    staticClass: "incisione-checkbox",
                                    attrs: {
                                      type: "checkbox",
                                      disabled: !_vm.jewelDescription
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.logo)
                                        ? _vm._i(_vm.logo, null) > -1
                                        : _vm.logo
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.logoSelection(
                                          $event.target.checked
                                        )
                                      },
                                      change: function($event) {
                                        var $$a = _vm.logo,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.logo = $$a.concat([$$v]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.logo = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.logo = $$c
                                        }
                                      }
                                    }
                                  })
                                ])
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm.isEngraveVisible
                      ? _c("div", { staticClass: "col-12 mb-3" }, [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass: "option-label row",
                                staticStyle: {
                                  "border-left": "none !important"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "option-label-title" },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "text-left mb-0 pl-5 text-uppercase label-menu d-flex"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("customizeEngraving")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "option-label-info" },
                                  [
                                    _c(
                                      "v-popover",
                                      {
                                        staticClass: "d-inline-block",
                                        attrs: {
                                          popoverClass:
                                            "tooltip-custom d-inline-block",
                                          placement: "top"
                                        }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          staticClass:
                                            "info-button cursor-pointer",
                                          attrs: {
                                            icon: ["fas", "info-circle"]
                                          }
                                        }),
                                        _c(
                                          "template",
                                          { slot: "popover" },
                                          [
                                            _c("JewelDescriptionTooltip", {
                                              attrs: {
                                                description: _vm.$t(
                                                  "tooltipCustomizeEngraving"
                                                )
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-10 pl-0" }, [
                                _vm.currentJewelSelection &&
                                _vm.currentJewelSelection.writingPrice &&
                                _vm.retailPerc === 1
                                  ? _c(
                                      "label",
                                      {
                                        staticClass:
                                          "text-left pl-5 incisione-label"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("addEngraving")) +
                                            " + " +
                                            _vm._s(
                                              _vm.currentJewelSelection.writingPrice
                                                .toFixed(2)
                                                .replace(".", ",")
                                            ) +
                                            "€ "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _c("div", { staticClass: "col-2 text-right" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.incisione,
                                      expression: "incisione"
                                    }
                                  ],
                                  staticClass: "incisione-checkbox",
                                  attrs: {
                                    type: "checkbox",
                                    disabled: !_vm.jewelDescription
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.incisione)
                                      ? _vm._i(_vm.incisione, null) > -1
                                      : _vm.incisione
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.incisioneSelection(
                                        $event.target.checked
                                      )
                                    },
                                    change: function($event) {
                                      var $$a = _vm.incisione,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.incisione = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.incisione = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.incisione = $$c
                                      }
                                    }
                                  }
                                })
                              ])
                            ]),
                            _c("div", { staticClass: "row pt-2 pl-5" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.incisioneLabel,
                                    expression: "incisioneLabel"
                                  }
                                ],
                                staticClass: "w-100 input-incisione",
                                style: {
                                  border:
                                    _vm.incisione && !_vm.incisioneLabel
                                      ? "1px solid red"
                                      : ""
                                },
                                attrs: {
                                  type: "text",
                                  placeholder: _vm.$t("max10Char", {
                                    char: _vm.currentCategory
                                      ? _vm.currentCategory.maxChars || 10
                                      : 10
                                  }),
                                  disabled: !_vm.incisione,
                                  maxlength: _vm.currentCategory
                                    ? _vm.currentCategory.maxChars || 10
                                    : 10
                                },
                                domProps: { value: _vm.incisioneLabel },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.incisioneLabel = $event.target.value
                                    },
                                    function($event) {
                                      return _vm.incisioneSelectionLabel()
                                    }
                                  ]
                                }
                              })
                            ])
                          ])
                        ])
                      : _vm._e()
                  ]),
                  _vm.isRhodiumTypeVisible
                    ? _c("div", { staticClass: "col-12 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "option-label row",
                            staticStyle: { "border-left": "none !important" }
                          },
                          [
                            _c("div", { staticClass: "col-6 pl-5" }, [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "text-left pl-0 text-uppercase label-menu"
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("bluing")) + " ")]
                              )
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "row pt-3 pl-5" }, [
                          _c(
                            "select",
                            {
                              staticClass: "w-100 select-setting",
                              staticStyle: { width: "inherit" },
                              domProps: { value: _vm.selectedBluing },
                              on: {
                                change: function($event) {
                                  return _vm.selectionBrunitura(
                                    $event.target.value
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "RHODIUM_NORMAL",
                                    selected: "selected"
                                  }
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("rhodium")) + " ")]
                              ),
                              _c(
                                "option",
                                { attrs: { value: "TIPS_BLUING" } },
                                [_vm._v(_vm._s(_vm.$t("tipsBluing")))]
                              ),
                              _c(
                                "option",
                                { attrs: { value: "RHODIUM_BLACK" } },
                                [_vm._v(_vm._s(_vm.$t("rhodiumBlack")))]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                2
              )
            : _vm._e(),
          _vm.isWarrantyVisible && _vm.isGioielleriaItalianaB2B
            ? _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  {
                    staticClass: "option-label row",
                    staticStyle: { "border-left": "none !important" }
                  },
                  [
                    _c("div", { staticClass: "pl-5" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-left pl-0 text-uppercase label-menu"
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("printWarranty")) + " ")]
                      )
                    ])
                  ]
                ),
                _c("div", { staticClass: "row pt-3 pl-5" }, [
                  _c("p", { staticClass: "mb-0 warranties-description" }, [
                    _vm._v(_vm._s(_vm.$t("warrantyDescription"))),
                    _c(
                      "a",
                      {
                        staticClass: "warranty-mail",
                        attrs: { href: "mailto:ivana@gioielleriaitaliana.com" }
                      },
                      [_vm._v("ivana@gioielleriaitaliana.com")]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }